import React from 'react'
import PropTypes from 'prop-types'

import { FormField } from '@campaignhub/suit-theme'

import serviceJobSortOptions from '@enums/serviceJobSortOptions'

const SortBy = (props) => {
  const { setJobState, jobState } = props
  const { sortBy, sortDirection } = jobState

  return (
    <>
      <FormField direction="column" label="Sort By" boxProps={{ paddingBottom: 'large' }}>
        <select onChange={e => setJobState({ sortBy: e.target.value })} value={sortBy}>
          {Object.values(serviceJobSortOptions).map(option => (
            <option key={option.key} value={option.key}>{option.label}</option>
          ))}
        </select>
      </FormField>
      <FormField direction="column" label="Order" boxProps={{ paddingBottom: 'large' }}>
        <select disabled={!sortBy} onChange={e => setJobState({ sortDirection: e.target.value })} value={sortDirection}>
          <option value="asc">Oldest First</option>
          <option value="desc">Newest First</option>
        </select>
      </FormField>
    </>
  )
}

SortBy.propTypes = {
  setJobState: PropTypes.func,
  jobState: PropTypes.object,
}

export default SortBy
